import React from "react";
import { FormattedMessage } from "react-intl";
import contractsEntityOptions from "../../contracts/config/entity";
import trucksEntityOptions from "../../trucks/config/entity";

export default [
    {
        name: "id",
        label: "Driver ID",
    },
    {
        id: "title",
        name: "name",
        label: <FormattedMessage id="driver.name" />,
        type: "string",
        isEditable: true,
    },
    {
        id: "image",
        name: "photo",
    },
    {
        name: "nationalId",
        label: <FormattedMessage id="driver.national-id" />,
        type: "string",
        isEditable: true,
    },
    {
        name: "phoneNumber",
        label: <FormattedMessage id="driver.phone-number" />,
        type: "string",
        isEditable: true,
        helpText: "Driver's Phone Number i.e 01234567890",
        errorMessage: "Phone Number is required and must be 11 digits starting with 0",
        validation: {
            pattern: /^0\d{10}$/,
            required: true,
        },
    },
    {
        name: "email",
        label: <FormattedMessage id="driver.email" />,
        type: "string",
        isEditable: true,
        errorMessage: "Email is required and should follow this pattern i.e. john@example.com",
        validation: {
            pattern: /\S+@\S+\.\S+/,
            required: true,
        },
    },
    {
        name: "isOnline",
        label: <FormattedMessage id="driver.is-online" />,
        type: "checkbox",
    },
    {
        name: "lastSeen",
        label: <FormattedMessage id="driver.last-seen" />,
        type: "dateAndTime",
    },
    {
        name: "lastContactedAt",
        label: <FormattedMessage id="driver.last-contacted" />,
        type: "dateAndTime",
    },
    {
        name: "clientVersion",
        label: <FormattedMessage id="driver.client-version" />,
        type: "string",
    },
    {
        name: "supplierId",
        label: <FormattedMessage id="driver.supplier" />,

        include: true,
        entityName: "suppliers",
        includeEntityName: "supplier",

        type: "list",
        isEditable: true,
        url: "/suppliers",
        filterValue: "name",
        errorMessage: "Supplier is required",
        validation: {
            required: true,
        },
    },
    {
        name: "trips",
        label: <FormattedMessage id="driver.trips" />,
        type: "relation",
        entityName: "trips",
    },
    {
        name: "contracts",
        label: <FormattedMessage id="driver.contracts" />,
        type: "relation",
        entityName: "contracts",
        entityOptions: contractsEntityOptions,
    },
    {
        name: "trucks",
        label: <FormattedMessage id="driver.trucks" />,
        type: "relation",
        entityName: "trucks",
        entityOptions: trucksEntityOptions,
    },
];
